import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const StyledConversationMessages = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 0.85rem;
  height: fit-content;
  max-height: 400px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 10px;
  background: #ffffff;
  padding: 1rem;
`;

export default StyledConversationMessages;
